import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getStripeLocationConfig = createSelector(creditCardsState, (cardsState) => cardsState.stripe.locationConfig);
